





























import { QDate, QInput, QPopupProxy } from "quasar";
import { Icon2 } from "@micad/vue-components";
import { defineComponent, reactive } from "@vue/composition-api";

function reformatDate(d: string): string {
  return /\d{4}\D\d{2}\D\d{2}/.exec(d)
    ? `${d.slice(8, 10)}-${d.slice(5, 7)}/${d.slice(0, 4)}`
    : d;
}

export default defineComponent({
  name: "DatePicker",
  components: {
    QInput,
    QDate,
    QPopupProxy,
    Icon2,
  },
  props: {
    label: String,
    value: String,
    mask: { type: String, default: "DD/MM/YYYY" },
  },
  setup(p, c) {
    return reactive({
      date: reformatDate(p.value || ""),
      update: (v: string) => {
        c.emit("update:value", v);
      },
    });
  },
});
